module.exports = __webpack_public_path__ + "static/media/ikea-filter.b0f1bb3f.jpeg";